import React, { Component } from "react";
// import GradientProgress from "../common/GradientProgress";
import { BankTile } from "../linkbank/components";
import { connect } from "react-redux";
import Logo from "../../assets/Logo";
import Back from "../../assets/Back";
import MailClosed from "../../assets/MailClosed";
import Phone from "../../assets/Phone";
import Edit from "../../assets/Edit";
import * as actions from "../../state/actions/onboarding";
import { track } from "../../api/heap";
import { withModal } from "../common";

class Confirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorSSN: null,
      shouldShowLoader: false
    };
  }

  componentDidMount() {
    if (!window.onbeforeunload) {
      window.onbeforeunload = () => {
        return "Refreshing this page will cause you to lose your application progress. Continue?";
      };
    }
  }

  handlePrevious = () => {
    this.props.previousStep();
  };

  handleNext = async () => {
    const {
      user: { termsAccepted, ppAccepted, email, ssn, hasResumed } = {},
      presubmissionCheck,
      hydrateStateWithToken,
      history,
      nextStep,
      step,
      updateStep,
      updateUserDatabase
    } = this.props;
    if (this.state.transitioning) return;
    this.setState({ transitioning: true });
    track("ONBOARDING_CONFIRM_STEP_CLICKED_CONTINUE");
    if (window.fbq != null) {
      window.fbq("track", "Application Submission");
    }
    if (window._tfa != null) {
      window._tfa.push({ notify: "event", name: "Application Submission" });
    }
    if (window.obApi != null) {
      window.obApi("track", "Application Submission");
    }
    if (window.dotq != null) {
      window.dotq.push({
        projectId: "10000",
        properties: {
          pixelId: "10171353",
          qstrings: {
            et: "custom",
            ec: "button",
            ea: "submit",
            el: "Application Submission"
          }
        }
      });
    }
    if (window.snaptr != null) {
      window.snaptr("track", "Application Submission");
    }

    if (!this.validate()) {
      this.setState({ transitioning: false });
      return;
    }

    if (
      (!this.props.linkedAccounts ||
        !Object.keys(this.props.linkedAccounts).length) &&
      (!this.props.finicityAccounts || !this.props.finicityAccounts.length)
    ) {
      track("ONBOARDING_ERROR_CONFIRM_STEP", {
        message: "no_linked_bank_accounts"
      });
      updateStep("confirm", {
        error: "You must link at least one bank account to continue"
      });
      this.setState({ transitioning: false });
      return;
    }

    await updateUserDatabase(this.props.user.email, {
      ...(hasResumed && { ssn }),
      applicationProgress: {
        termsAccepted,
        ppAccepted,
        lastCompletedStep: 7,
        confirm: true,
        lastUpdated: new Date()
      }
    });

    if ((step || {}).stepIsComplete) {
      this.props.updateStep("processingApplication", { error: null });
      nextStep();
      return;
    }

    const balanceCheck = await presubmissionCheck();
    this.props.updateStep("confirm", { stepIsComplete: true });

    if (!(balanceCheck || {}).data.ok) {
      this.setState({ shouldShowLoader: true });
      if (!(balanceCheck || {}).data.linked) {
        const jwt = window.localStorage.getItem("jwt");
        // We call hydrateStateWithToken here because it populates any plaid unlinked accounts in the redux store
        await hydrateStateWithToken({ email, jwt });
      }
      history.push({ pathname: "/processingapplication" });
      return;
    } else {
      this.props.updateStep("processingApplication", { error: null });
      nextStep();
      return;
    }
  };

  validate = () => {
    const { user: { termsAccepted, ppAccepted } = {} } = this.props;

    if (!termsAccepted || !ppAccepted) {
      this.setState({ errorTerms: "You must accept these terms to continue" });
      this.setState({ transitioning: false });
      return false;
    }

    if (termsAccepted && ppAccepted) {
      this.setState({ errorTerms: null });
    }

    return true;
  };

  renderFinicityAccounts = ({ type } = {}) => {
    const {
      finicityAccounts = [],
      finicityInstitutions = {},
      removeFinicityAccount,
      step: { loading } = {}
    } = this.props;
    let accounts;
    if (type === "depository") {
      accounts = finicityAccounts.filter(a =>
        ["checking", "savings"].includes(a.type)
      );
    } else if (type === "investment") {
      accounts = finicityAccounts.filter(
        a => !["checking", "savings"].includes(a.type)
      );
    } else {
      accounts = finicityAccounts;
    }

    const getLogo = id =>
      ((finicityInstitutions[id] || {}).branding || {}).icon;

    return accounts.map(a => {
      const logo = getLogo(a.institution_id);
      return (
        <BankTile
          logoUrl={logo}
          name={a.name}
          accountNumber={a.mask}
          handleRemove={() => removeFinicityAccount(a.id)}
          disabled={loading}
        />
      );
    });
  };

  render() {
    const {
      handleNext,
      handlePrevious,
      renderFinicityAccounts,
      state: { errorSSN, errorTerms }
    } = this;
    const {
      user: {
        firstName,
        lastName,
        email,
        phoneNumber,
        address,
        city,
        state,
        zip,
        dob,
        ssn,
        termsAccepted,
        ppAccepted,
        estimatedLimit,
        shippingAddress,
        shippingAddress: {
          address: shipping_address,
          city: shipping_city,
          state: shipping_state,
          zip: shipping_zip,
          unitNumber: shipping_unit_number,
          normalizedAddress: {
            address_street: shipping_normalized_address,
            address_city: shipping_normalized_city,
            address_subdivision: shipping_normalized_state,
            address_postal_code: shipping_normalized_zip
          } = {}
        } = {}
      } = {},
      linkedAccounts,
      finicityAccounts,
      institutions,
      history,
      isMobile,
      removeAccount,
      updateUser,
      step: { error } = {}
    } = this.props;

    // Strip the (assumed) country code.
    const pn = phoneNumber.toString().replace("+1", "");
    const s = ssn.toString();

    const renderPersonalDetails = ({
      firstName,
      lastName,
      dob,
      ssn,
      address,
      city,
      state,
      zip,
      shipping_address,
      shipping_city,
      shipping_state,
      shipping_zip
    }) => {
      return (
        <div className="text-left">
          <div className="font-bold w-full">
            {(firstName || "Unknown") + " " + (lastName || "Unknown")}
          </div>
          <div className="w-full flex justify-between text-xs">
            <div className="flex-1">
              <div>{address || "Unknown address"}</div>
              <div>
                {city || "Unknown"}, {state || "Unknown"} {zip || "Unknown"}
              </div>
            </div>
            <div className="">{renderDOBSSN(dob, ssn)}</div>
          </div>

          {shipping_address && (
            <div className="mt-2">
              <div className="w-full text-xs">
                <p className="font-bold">Shipping address:</p>
                <div>{shipping_address || "Unknown address"}</div>
                <div>
                  {shipping_city || "Unknown"}, {shipping_state || "Unknown"}{" "}
                  {shipping_zip || "Unknown"}
                </div>
              </div>
            </div>
          )}
        </div>
      );
    };

    const renderDOBSSN = (dob, ssn) => {
      return (
        <div className="text-left text-xs">
          <div>
            <span style={{ fontFamily: "HelveticaNeue-Bold" }}>DOB: </span>
            <span>
              {dob
                ? `${dob.slice(4, 6)}/${dob.slice(6, 8)}/${dob.slice(0, 4)}`
                : "Unknown"}
            </span>
          </div>
          <div>
            <span style={{ fontFamily: "HelveticaNeue-Bold" }}>SSN: </span>
            <span>
              {s ? `XXX-XX-${s.slice(s.length - 4, s.length)}` : "XXX-XX-XXXX"}
            </span>
          </div>
        </div>
      );
    };

    const renderEmail = (email, containerClassName) => {
      return (
        <div className={containerClassName}>
          <MailClosed className="inline-block" defaultWidth={16} />
          <span className="ml-2">{email || "Unknown email"}</span>
        </div>
      );
    };

    const renderPhone = (phone, containerClassName) => {
      return (
        <div className={containerClassName}>
          <Phone className="inline-block" defaultHeight={16} />
          <span className="ml-2">
            {phoneNumber
              ? `+1 ${pn.slice(0, 3)}-${pn.slice(3, 6)}-${pn.slice(6, 10)}`
              : "Unknown"}
          </span>
        </div>
      );
    };

    const renderLinkedAccounts = (allowAdd = true, separate = false) => {
      const {
        props: {
          context: { openModal },
          accountWarnings,
          step: { loading } = {}
        }
      } = this;
      const isBank = account => {
        const types = ["checking", "savings", "money market"];
        return types.includes(account.type) || types.includes(account.subtype);
      };
      const isInvestment = account => {
        const types = [
          "cd",
          "401k",
          "brokerage",
          "ira",
          "pension",
          "roth",
          "roth 401k"
        ];
        return types.includes(account.type) || types.includes(account.subtype);
      };
      const getInstitutionLogo = name => {
        return (
          institutions &&
          (institutions.filter(i => i.brand_name === name).pop() || {}).logo
        );
      };
      const bankAccounts = Object.keys(linkedAccounts || {}).reduce((a, k) => {
        const la = linkedAccounts[k];
        la.forEach(account => {
          if (isBank(account)) {
            a.push({
              id: account.id,
              logo: getInstitutionLogo(k) || null,
              name: account.name || account.nickname,
              mask: account.mask,
              identity_valid: account.identity_valid,
              identity_details: account.identity_details
            });
          }
        });
        return a;
      }, []);
      const investmentAccounts = Object.keys(linkedAccounts || {}).reduce(
        (a, k) => {
          const la = linkedAccounts[k];
          la.forEach(account => {
            if (isInvestment(account)) {
              a.push({
                id: account.id,
                logo: getInstitutionLogo(k) || null,
                name: account.name || account.nickname,
                mask: account.mask,
                identity_valid: account.identity_valid,
                identity_details: account.identity_details
              });
            }
          });
          return a;
        },
        []
      );

      const finicityInvestmentAccounts = (finicityAccounts || []).filter(
        a => !["checking", "savings"].includes(a.type)
      );

      const renderAddMoreButton = () => {
        return (
          <div
            className={
              "addAccBtn w-full py-2 rounded text-lg bg-green-primary text-white cursor-pointer"
            }
            onClick={() => {
              this.props.history.push(`/linkbank${window.location.search}`);
            }}
          >
            {"+ Add more"}
          </div>
        );
      };

      const renderLoadingIndicator = loading => (
        <div
          className="loader"
          style={{
            height: 60,
            width: 60,
            margin: "auto",
            visibility: loading ? "visible" : "hidden"
          }}
        ></div>
      );

      const depositoryAccountLinked =
        !!Object.keys(linkedAccounts || {}).find(
          i =>
            !!linkedAccounts[i].find(a =>
              ["checking", "savings"].includes(a.subtype)
            )
        ) ||
        !!(finicityAccounts || []).find(i =>
          ["checking", "savings"].includes(i.type)
        );

      return separate ? (
        <div className="my-4 pt-2">
          <div className="font-gilroy font-light text-lg pb-3">
            Bank accounts
          </div>
          <div className="mb-4">
            {renderFinicityAccounts({ type: "depository" })}
            {bankAccounts.map(a => (
              <BankTile
                logo={a.logo}
                name={a.name || a.nickname}
                accountNumber={a.mask}
                triggerOnHover={!isMobile}
                handleRemove={() => {
                  removeAccount(a.id);
                }}
              />
            ))}
            {allowAdd && renderAddMoreButton()}
          </div>
          {(investmentAccounts.length > 0 ||
            finicityInvestmentAccounts.length > 0) && (
            <>
              <div className="font-gilroy font-light text-lg pb-3">
                Other accounts
              </div>
              <div className="mb-4">
                {investmentAccounts.map(a => (
                  <BankTile
                    logo={a.logo}
                    name={a.name || a.nickname}
                    accountNumber={a.mask}
                    triggerOnHover={!isMobile}
                    handleRemove={() => {
                      removeAccount(a.id);
                    }}
                  />
                ))}
              </div>
            </>
          )}
          {renderFinicityAccounts({ type: "investment" })}
          {loading && renderLoadingIndicator(loading)}
          {allowAdd && !loading && renderAddMoreButton()}
        </div>
      ) : depositoryAccountLinked ? (
        <div className="my-4 pt-2">
          <div className="font-gilroy font-light text-lg pb-3">
            Linked accounts
          </div>
          {renderFinicityAccounts()}
          {Object.keys(linkedAccounts || []).map(key => {
            const la = linkedAccounts[key];
            return la.map(a => {
              const i =
                institutions &&
                institutions.filter(i => i.brand_name == key)[0];
              return (
                <BankTile
                  logo={i && i.logo}
                  name={a.name || a.nickname}
                  accountNumber={a.mask}
                  triggerOnHover={!isMobile}
                  handleRemove={() => {
                    removeAccount(a.id);
                  }}
                  showWarning={
                    !([true, false].includes(a.identity_valid)
                      ? a.identity_valid
                      : true)
                  }
                  warningAction={e => {
                    const filteredWarnings = (accountWarnings || []).filter(
                      w => w.id === a.id
                    );
                    const filteredBankAccounts = (bankAccounts || []).filter(
                      b => b.id === a.id
                    );
                    const filteredInvestmentAccounts = (
                      investmentAccounts || []
                    ).filter(b => b.id === a.id);
                    let ourWarning = [];
                    if (filteredBankAccounts.length)
                      ourWarning = filteredBankAccounts.reduce(
                        (a, i) => [
                          ...a,
                          {
                            account: {
                              id: i.id,
                              mask: i.mask,
                              nickname: i.name,
                              type: i.type
                            },
                            details: ((i.identity_details || [])[0] || {})
                              .results
                          }
                        ],
                        []
                      );
                    if (!(ourWarning || []).length) {
                      if (investmentAccounts.length)
                        ourWarning = filteredInvestmentAccounts.reduce(
                          (a, i) => [
                            ...a,
                            {
                              account: {
                                id: i.id,
                                mask: i.mask,
                                nickname: i.name,
                                type: i.type
                              },
                              details: ((i.identity_details || [])[0] || {})
                                .results
                            }
                          ],
                          []
                        );
                    }
                    if (filteredWarnings.length) ourWarning = filteredWarnings;
                    openModal(e, "LinkBankWarningsDetailsModal", {
                      accountWarnings: ourWarning
                    });
                  }}
                />
              );
            });
          })}
          {loading && renderLoadingIndicator(loading)}
          {allowAdd && !loading && renderAddMoreButton()}
        </div>
      ) : (
        <div className="mb-4 py-4">
          <div className="font-gilroy font-light text-lg pb-3">
            Linked accounts
          </div>
          {loading && renderLoadingIndicator(loading)}
          {allowAdd && !loading && renderAddMoreButton()}
          <p className="text-sm my-5 text-red-500">
            You cannot continue without linking at least one checking or savings
            account!
          </p>
        </div>
      );
    };

    const renderEditContainer = (children, editAction) => {
      return (
        <div className="shadow flex rounded-sm">
          <div className="p-3 flex-1 bg-white">{children}</div>
          {editAction && (
            <div
              className="cursor-pointer flex ml-px bg-white"
              style={{ width: 30 }}
              onClick={editAction}
            >
              <div className="inline-block w-px h-full float-left" />
              <Edit className="inline-block m-auto" />
            </div>
          )}
        </div>
      );
    };

    // Set true if you want email && phone fields to line up
    // horizontally instead of stacking vertically
    const separateOtherFields = true;

    const ageToDisplay = state === "AL" ? "19" : "18";
    const { shouldShowLoader } = this.state;
    return (
      <>
        {/* outerStack-mobile sm:outerStack needs marginBotton if there is a bottomBar */}
        <div className="outerStack-mobile sm:outerStack">
          {shouldShowLoader ? (
            <div
              className="loader"
              style={{
                height: 180,
                width: 180,
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "80px"
              }}
            />
          ) : (
            <div className="innerStack">
              <div className="stepDescriptionText">Review Your Application</div>
              {/*<GradientProgress
                    value={estimatedLimit || 0}
                    title="Estimated spending power:"
                    maxLabel="$5000+"
                  />*/}
              {renderEditContainer(
                renderPersonalDetails({
                  firstName,
                  lastName,
                  address,
                  city,
                  state,
                  zip,
                  dob,
                  ssn,
                  shipping_address:
                    shipping_normalized_address ||
                    (shipping_address
                      ? `${shipping_address}${
                          shipping_unit_number
                            ? ` Unit ${shipping_unit_number}`
                            : ""
                        }`
                      : null),
                  shipping_city: shipping_city,
                  shipping_state: shipping_state,
                  shipping_zip: shipping_zip
                })
                // editPersonalInformation
              )}
              <div className={`mt-2 ${separateOtherFields && "md:flex"}`}>
                <div
                  className={`flex-1 text-left ${separateOtherFields &&
                    "md:inline-block"}`}
                >
                  {renderEditContainer(
                    renderEmail(email, separateOtherFields ? "text-xs" : null)
                  )}
                </div>
                <div
                  className={`mt-2 text-left ${separateOtherFields &&
                    "md:inline-block md:ml-3 md:mt-0 md:text-center"}`}
                >
                  {renderEditContainer(
                    renderPhone(
                      phoneNumber,
                      separateOtherFields ? "text-xs" : null
                    )
                  )}
                </div>
              </div>
              {renderLinkedAccounts()}
              <div style={{ fontSize: 14 }}>
                {errorTerms && <div className="errorText">{errorTerms}</div>}
                <input
                  type="checkbox"
                  checked={ppAccepted && termsAccepted}
                  name="tos"
                  onClick={e => {
                    console.log("Clicky updateUser");
                    updateUser({
                      termsAccepted: e.target.checked,
                      ppAccepted: e.target.checked
                    });
                    if (!e.target.checked) {
                      this.setState({
                        errorTerms: "You must accept these terms to continue"
                      });
                    } else {
                      this.setState({
                        errorTerms: null
                      });
                    }
                  }}
                ></input>
                <span className="ml-2 font-open-sans text-sm">
                  {/* This margin causes widening of other input fields*/}
                  {`By continuing I certify that I am ${ageToDisplay} years of age, and I
                      agree to the`}
                </span>{" "}
                <a
                  href="https://tomo-public-docs.s3.us-west-1.amazonaws.com/TermsOfUse.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary font-open-sans"
                >
                  Terms of Use
                </a>
                <span>, </span>
                <a
                  href="/privacypolicy"
                  target="_blank"
                  className="text-primary font-open-sans"
                >
                  Privacy Policy
                </a>
                <span>, and </span>
                <a
                  href="https://tomo-public-docs.s3.us-west-1.amazonaws.com/Tomo-+ESIGN+Consent+Disclosure.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary font-open-sans"
                >
                  e-Sign.
                </a>
              </div>
              {/*
                  {error && renderError(error)}
                  <div style={{ fontSize: 14 }}>
                    {errorTerms && <div className="errorText">{errorTerms}</div>}
                    <input
                      type="checkbox"
                      checked={ppAccepted && termsAccepted}
                      name="tos"
                      onClick={e => {
                        updateUser({
                          termsAccepted: e.target.checked,
                          ppAccepted: e.target.checked
                        });
                      }}
                    ></input>
                    <span className="ml-2 font-open-sans text-sm text-gray-600">
                      By continuing I certify that I am 18 years of age, and I
                      agree to the User Agreement and Privacy Policy
                    </span>
                  </div>
                  */}
              <div>
                <input
                  type="button"
                  name="button"
                  value="Submit"
                  disabled={this.state.transitioning}
                  onClick={handleNext}
                  className="gtm-submit-application continueButton cursor-pointer"
                />
              </div>
            </div>
          )}
        </div>
        <div className="bottomBar md:absolute inset-x-0 bottom-0">
          <div className="bottomBarText-mobile sm:bottomBarText">
            <div>
              <div onClick={handlePrevious}>
                <Back className="backButtonIcon" />
                <input
                  type="button"
                  name="button"
                  value="Back"
                  className="backButton"
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(
  state => ({
    user: state.register.user,
    step: state.register.confirm,
    linkedAccounts: state.register.linkBank.linkedAccounts,
    finicityAccounts: state.register.linkBank.finicityAccounts,
    accountWarnings: state.register.linkBank.accountWarnings,
    institutions: state.register.linkBank.institutions,
    finicityInstitutions: state.register.linkBank.finicityInstitutions
  }),
  actions
)(withModal(Confirm));
